import PreguntaConfirmacionRow from "./PreguntaConfirmacionRow";

const PreguntasConfirmacionTable = ({ preguntas, search }) => {
  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Pregunta</th>
            <th>Estado</th>
            <th>Fecha creación</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {preguntas.map((pregunta) => (
            <PreguntaConfirmacionRow
              key={pregunta.id}
              pregunta={pregunta}
              search={search}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PreguntasConfirmacionTable;
